unable to read source [project]/packages/react/src/renderToStyleElements.ts